<button
  #trigger
  class="filter"
  type="button"
  [class.is-open]="open"
  [attr.aria-label]="label"
  aria-haspopup="menu"
  [attr.aria-expanded]="open"
  [attr.aria-controls]="open ? menuId : null"
  (click)="toggle()">
  <img class="filter__icon" src="assets/images/render/account/filter.svg" width="29" height="21" alt="" />
</button>

<div *ngIf="open" #menu class="filter-menu" [id]="menuId" role="menu" aria-label="Show in your library" (keydown)="onMenuKeydown($event)">
  <button
    *ngFor="let filter of filters"
    class="filter-menu__item"
    type="button"
    role="menuitemradio"
    [attr.aria-checked]="filter.id === value"
    (click)="choose(filter.id)">
    <span>{{ filter.label }}</span>
    <img *ngIf="filter.id === value" class="filter-menu__check" src="assets/images/render/account/filter-check.svg" width="16" height="11.8" alt="" />
  </button>
</div>
